module.exports = __webpack_public_path__ + "static/media/mewtwo.276f9acb.png";